import React from 'react';
import SectionCard from 'components/organisms/section_card';
import { ResumoContent } from '../styles';

interface Block {
  title?: string;
  items: string[];
}

const TIMESTAMP_ONLY = /^\[[^\]]*\]$/;
const LABELLED_ITEM = /^([^:[\]]{2,60}):\s*(.*)$/;

const addBody = (body: string, block: Block) => {
  body
    .split(/\s+-\s+/)
    .map((fragment) => fragment.trim())
    .filter(Boolean)
    .forEach((fragment) => {
      const last = block.items[block.items.length - 1];

      if (last && TIMESTAMP_ONLY.test(last)) {
        block.items[block.items.length - 1] = `${last} ${fragment}`;
      } else {
        block.items.push(fragment);
      }
    });
};

const parseResumo = (raw: string): Block[] => {
  const blocks: Block[] = [];
  let current: Block | null = null;

  raw.split(/\*\*(.+?)\*\*/g).forEach((part, index) => {
    const text = part.trim();

    if (index % 2 === 1) {
      current = { title: text, items: [] };
      blocks.push(current);
      return;
    }

    if (!text) return;

    if (!current) {
      current = { items: [] };
      blocks.push(current);
    }

    addBody(text, current);
  });

  return blocks;
};

const renderItem = (item: string) => {
  const match = item.match(LABELLED_ITEM);

  if (match) {
    return (
      <>
        <strong>{match[1]}:</strong> {match[2]}
      </>
    );
  }

  return item;
};

const ResumoSection = ({ data }: any) => {
  if (!data) return null;

  const blocks = parseResumo(String(data));

  if (!blocks.some((block) => block.title)) {
    return (
      <SectionCard title="Resumo do chat" icon="description">
        <p className="mb-0">{data}</p>
      </SectionCard>
    );
  }

  return (
    <SectionCard title="Resumo do chat" icon="description">
      <ResumoContent>
        {blocks.map((block) => (
          <div className="resumo-block" key={block.title ?? block.items.join('|')}>
            {block.title && <h6 className="resumo-title">{block.title}</h6>}
            {block.items.length > 0 && (
              <ul className="resumo-list">
                {block.items.map((item) => (
                  <li key={item}>{renderItem(item)}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </ResumoContent>
    </SectionCard>
  );
};

export default ResumoSection;
